export interface BuildAppUrlOptions {
  transformUrl?: (url: string) => string;
  skipLang?: boolean;
  appendParams?: string;
  appendAccountIdParam?: string;
}

export function buildAppUrl(
  rawUrl: string,
  locale: string,
  accountId: string,
  options: BuildAppUrlOptions = {}
): string {
  const { transformUrl, skipLang, appendParams, appendAccountIdParam } =
    options;
  const transformedUrl = transformUrl ? transformUrl(rawUrl) : rawUrl;

  const hashIndex = transformedUrl.indexOf("#");
  const base =
    hashIndex !== -1 ? transformedUrl.slice(0, hashIndex) : transformedUrl;
  const hash = hashIndex !== -1 ? transformedUrl.slice(hashIndex) : "";

  const ccLocale = locale.replace("-", "_");
  const additionalParams: string[] = [];
  if (!skipLang) {
    additionalParams.push(`lang=${ccLocale}`);
  }
  if (appendParams) {
    additionalParams.push(appendParams);
  }
  if (appendAccountIdParam) {
    additionalParams.push(`${appendAccountIdParam}=${accountId}`);
  }

  return additionalParams.length > 0
    ? `${base}${base.includes("?") ? "&" : "?"}${additionalParams.join("&")}${hash}`
    : `${base}${hash}`;
}
